'use client';

import GenericHeader from 'app/components/header/header';
import { useSearchParams } from 'next/navigation';
import { useLocale } from 'next-intl';
import { useTranslation } from '@/app/i18n/client';
import { PageBanner } from '@/types/contentful';
const VALID_ERROR_KEYS = ['unverified', 'invalid_billing_cycle', 'invalid_currency', 'partnership_not_found', 'unexpected_error', 'invalid_success_url', 'invalid_cancel_url', 'unauthorized', 'already_on_pro', 'no_subscription_to_upgrade'];
export function Header() {
  const locale = useLocale();
  const {
    t
  } = useTranslation(locale, 'pricing_v2_3');
  const searchParams = useSearchParams();
  let errorBanner: PageBanner | undefined = undefined;
  const error = searchParams?.get('error');
  if (error) {
    const errorKey = VALID_ERROR_KEYS.some(key => key === error) ? error : 'unexpected_error';
    errorBanner = {
      routes: ['/pricing'],
      website: 'todoist',
      message: t(`errors.${errorKey}`, {
        currency: searchParams?.get('currency')?.toUpperCase() ?? ''
      }),
      localeSpecific: [],
      dismissible: false
    };
  }
  return <GenericHeader pageBanner={errorBanner} data-sentry-element="GenericHeader" data-sentry-component="Header" data-sentry-source-file="header.tsx" />;
}